import React from "react";

export const Check = ({ checked, onChange, data }) => {

	return (
        <input 
            style={{ cursor: 'pointer' }} 
            checked={ checked } 
            type='checkbox' 
            onChange={ (e) => onChange(e?.target?.checked, data) } 
        />
    );
}